import React from "react";
import TextBlock from "./elements/TextBlock";
import CenteredContentWrapper from '../elements/CenteredContentWrapper';

export default class CapsuleBlock extends React.PureComponent {
    render() {
        return (
            <div className={'palette'}>
                <CenteredContentWrapper className={'info'}>
                    <div className={'main-title'}>
                        <span className={'highlighted'}>Capsule</span> is an intuitive and innovative synthesis engine that concentrates its intricate sound design into eight easy-to-use macro controls
                    </div>

                    <TextBlock>Making music production more accessible and free-flowing.</TextBlock>
                </CenteredContentWrapper>
            </div>
        );
    }
}

